// The audit event VOCABULARY: the closed `AuditEventKind` set every row is keyed
// by, assembled from the six subject groups beside this file (`kind-housekeeping` is the
// second file of the maintenance group, spread right after it so the order holds), plus the edge
// validator and the type derived from it.
//
// The groups are a FILE split, never a semantic one — `AuditEventKind` is one flat
// closed vocabulary and a kind belongs to whichever group its neighbours are in.
// The object below is the only place they compose, and `audit.test.ts` proves the
// composition is a PARTITION: a key declared in two groups would be silently
// overwritten by the later spread, where the single object literal this replaced
// was a `ts(1117)` duplicate-key error.
// Split out of `../audit.ts`, which is now the barrel over this directory.
//
// `AuditEventKindSchema` is `z.enum(AuditEventKind)`, so the spread order and each
// group's key order ARE the enum order the OpenAPI document publishes for
// `GET /v1/audit/events?kind=`. Moving a key between or within groups reorders it.

import { z } from 'zod';
import { AUDIT_KIND_COMMERCE } from './kind-commerce';
import { AUDIT_KIND_DISPATCH } from './kind-dispatch';
import { AUDIT_KIND_HOUSEKEEPING } from './kind-housekeeping';
import { AUDIT_KIND_LOOP } from './kind-loop';
import { AUDIT_KIND_MAINTENANCE } from './kind-maintenance';
import { AUDIT_KIND_REVIEW } from './kind-review';

export const AuditEventKind = {
  ...AUDIT_KIND_LOOP,
  ...AUDIT_KIND_DISPATCH,
  ...AUDIT_KIND_MAINTENANCE,
  ...AUDIT_KIND_HOUSEKEEPING,
  ...AUDIT_KIND_COMMERCE,
  ...AUDIT_KIND_REVIEW,
} as const;
export const AuditEventKindSchema = z.enum(AuditEventKind);
export type AuditEventKind = z.infer<typeof AuditEventKindSchema>;
